import React from 'react';

const LegendContent = () => {
    return (
        <>
            <div className="chart-divisor"></div>

            <section className="mt-4 flex flex-col">
                <span className={'font-bold text-[16px]'}>Legenda - Placa pesquisada:</span>

                <article><span className={'font-bold text-[17px] pr-1'}>+ :</span> Somente placas lidas pelo sistema</article>
                <article><span className={'font-bold text-[17px] pr-1'}>- :</span> Somente placas não lidas pelo sistema</article>
                <article><span className={'font-bold text-[17px] pr-1'}>? :</span> Assume qualquer caractere na posição localizada</article>
                <article><span className={'font-bold text-[17px] pr-1'}>* :</span> Assume qualquer sequência de caracteres na posição localizada</article>
            </section>

        </>
    );
};

export default LegendContent;